import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFilePdf, faFileWord, faFileExcel } from '@fortawesome/free-solid-svg-icons';

const ICONS = {
    'application/pdf': faFilePdf,
    'application/msword': faFileWord,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': faFileWord,
    'application/vnd.ms-excel': faFileExcel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': faFileExcel,
}

const MimeIcon = ({ mime }) => {
    let icon = faFile;
    if (ICONS.hasOwnProperty(mime)) {
        icon = ICONS[mime];
    }
    return <i style={{ fontSize: '1.5rem' }}><FontAwesomeIcon icon={icon} /></i>;
}

export default MimeIcon;